import React from 'react';
import { cn } from './utils';

export type BadgeVariant = 'brand' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const variantClass: Record<BadgeVariant, string> = {
  brand: '',
  success: 'bh-badge--success',
  warning: 'bh-badge--warning',
  danger: 'bh-badge--danger',
  info: 'bh-badge--info',
  neutral: 'bh-badge--neutral',
};

export function Badge({ variant = 'brand', className, children, ...rest }: BadgeProps) {
  return (
    <span className={cn('bh-badge', variantClass[variant], className)} {...rest}>
      {children}
    </span>
  );
}
